export default family => state => {
  const offerId = state.offers?.[family]?.offerId;
  return state.offers?.data?.[offerId]?.terms?.[0]?.price;
};
